function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import GridModel from "./GridModel.js";
/**
 * A simple model that displays static data
 */
class StaticDataGridModel extends GridModel {
  /**
   * Create a model using the static data provided
   * @param data Row data to display. First dimension is the number of rows, second dimension is the value for each column. Row/column count is derived from the data, and it is stringified for display.
   * @param columnHeaders Optional names for the column headers
   */
  constructor(data, columnHeaders) {
    var _columnHeaders$length;
    super();
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "columnHeaders", void 0);
    _defineProperty(this, "numberOfColumns", void 0);
    this.data = data;
    this.numberOfColumns = Math.max(...data.map(row => row.length), (_columnHeaders$length = columnHeaders === null || columnHeaders === void 0 ? void 0 : columnHeaders.length) !== null && _columnHeaders$length !== void 0 ? _columnHeaders$length : 0);
    this.columnHeaders = columnHeaders;
  }
  get rowCount() {
    return this.data.length;
  }
  get columnCount() {
    return this.numberOfColumns;
  }
  textForCell(column, row) {
    var _this$data$row;
    return "".concat((_this$data$row = this.data[row]) === null || _this$data$row === void 0 ? void 0 : _this$data$row[column]);
  }
  textForColumnHeader(column) {
    var _this$columnHeaders$c, _this$columnHeaders;
    return (_this$columnHeaders$c = (_this$columnHeaders = this.columnHeaders) === null || _this$columnHeaders === void 0 ? void 0 : _this$columnHeaders[column]) !== null && _this$columnHeaders$c !== void 0 ? _this$columnHeaders$c : '';
  }
}
export default StaticDataGridModel;
//# sourceMappingURL=StaticDataGridModel.js.map